export default "__VITE_ASSET__BxA_WJ5x__"